import Pill from "../Pill/Pill";
import styles from "./Hero.module.css";
import { processSteps } from "./Hero.controller";

const Hero = () => {
  return (
    <section className={styles.hero} id="home">
      <div className={styles.heroContent}>
        <Pill label="From idea to launch" />
        <h1 className={styles.title}>
          Turning bold ideas into bespoke digital products
        </h1>
        <p className={styles.lede}>
          We can turn your business or your idea into a standout website or app
          - strategy, design, and engineering working together to create
          experiences your customers will love.
        </p>
        <div className={styles.heroActions}>
          <a className={`${styles.btn} ${styles.primary}`} href="#contact">
            Talk to us
          </a>
          <a className={`${styles.btn} ${styles.ghost}`} href="#services">
            Explore services
          </a>
        </div>
        <div className={styles.processRow}>
          {processSteps.map((step, idx) => (
            <div key={step.title} className={styles.processCard}>
              <div className={styles.stepBadge}>{String(idx + 1).padStart(2, "0")}</div>
              <div className={styles.stepTitle}>{step.title}</div>
              <div className={styles.stepDescription}>{step.description}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
